import React from 'react';
import { injectIntl } from '@kyruus/intl';
import Print from '@kyruus/react-ikons/Print';

import { SearchBreadcrumbs } from './SearchBreadcrumbs';
import SocialShareMenu, { IconWithLabel } from './social-share-menu';
import { messages as socialMessages } from '../profile/share-profile';
import { SearchLinksContainer, SocialWrapper, PrintOptions } from './styles';

const SearchLinks = ({ profile, currentQuery, config, log, device, intl }) => {
  const showPrint = !device.isWebview; /** disable print on webview */

  return (
    <SearchLinksContainer id="SearchLinksContainer">
      {profile?.provider && (
        <SearchBreadcrumbs
          provider={profile.provider}
          config={config}
          currentQuery={currentQuery}
          log={log}
        />
      )}
      <SocialWrapper>
        {profile ? (
          <PrintOptions>
            <SocialShareMenu
              profile={profile}
              config={config}
              intl={intl}
              log={log}
            />
          </PrintOptions>
        ) : null}

        {showPrint && (
          <IconWithLabel
            data-testid="PrintProfileButton"
            icon={<Print tabIndex="-1" aria-hidden={true} size="21px" />}
            label={intl.formatMessage(socialMessages.printlabel)}
            onClick={() => print()}
            aria-label={intl.formatMessage(
              socialMessages.printProviderProfileAriaLabel
            )}
          />
        )}
      </SocialWrapper>
    </SearchLinksContainer>
  );
};

export default injectIntl(SearchLinks);
